var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimatedLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "animated-logo-mark_svg__edrbBO0v3ap1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "347 -10 160 160",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@keyframes edrbBO0v3ap13_tr__tr{0%{transform:translate(426.195px,70px) rotate(0deg);animation-timing-function:cubic-bezier(.86,0,.07,1)}57.142857%{transform:translate(426.195px,70px) rotate(2deg)}to{transform:translate(426.195px,70px) rotate(0deg)}}@keyframes edrbBO0v3ap13_ts__ts{0%{transform:scale(0,0);animation-timing-function:cubic-bezier(.86,0,.07,1)}57.142857%{transform:scale(1.1,1.1);animation-timing-function:cubic-bezier(.645,.045,.355,1)}to{transform:scale(1,1)}}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.667A6.667 6.667 0 016.667 0H136a4 4 0 014 4v129.333a6.667 6.667 0 01-6.667 6.667C59.695 140 0 80.305 0 6.667z",
    transform: "matrix(0 0 0 0 426.195 70)",
    fill: "#105ed5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedLogoMark);
export default __webpack_public_path__ + "static/media/animated-logo-mark.2cd607bd89f504b36c6e21e985745105.svg";
export { ForwardRef as ReactComponent };